// extracted by mini-css-extract-plugin
export default {"content-carousel":"Brxn0p","content-carousel__header":"xsc2sG","content-carousel__description":"jeBe9e"};